<template>
 <div class="container ">
  <div class="displya-none-m">
    <div>
      <ul class="nev-desk">
        <li class="linev nev-img-d"><a href="/"><img src="/static/img/crp-images/Logo_RCP_Smart_App.png" style=" width: 90%;" alt="Logo" ></a></li>
        <li class="linev nev-url-d">
          <ul class="ul-nev-url">
            <li class="ulli-url"><router-link to="/videos" class="link-url">VIDEOS</router-link></li>
            <li class="ulli-url"><router-link to="/documents" class="link-url">MANUALS</router-link></li>
            <li class="ulli-url"><router-link to="/products-view" class="link-url">PRODUCTS</router-link></li>
            <li class="ulli-url"><router-link to="/favourite" class="link-url">FAVOURITES</router-link></li>
          </ul>
        </li>
        <li class="linev nev-cart-d">
          <md-badge :md-content='itemCount'>
            <md-button class="md-icon-button" @click="showCart">
              <md-icon>shopping_cart</md-icon>
            </md-button>
          </md-badge>
        </li>
        <li class="linev nev-search-d">
          <div class="mainSearchBar">
             <input type="text" v-model="searchKeyWord" v-on:keyup.enter="SearchItems" class="searchTerm searchMain" placeholder="What are you looking for?">
             <!-- <a :href="$router.resolve({path: '/search-items?search=' + searchKeyWord}).href"> -->
               <button type="button"  @click="SearchItems()"  class="mainSearchButton">
                 <i class="fa fa-search"></i>
               </button>
             <!-- </a> -->
          </div>
        </li>
        <li class="linev nev-pro-d">
          <md-menu md-size="medium" md-align-trigger>
            <md-button class="md-icon-button" md-menu-trigger>
              <md-avatar v-if="this.proIMG != null">
                <img class="user-image" :src="'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/profile/'+this.proIMG" alt="User profile image" />
              </md-avatar>
              <md-avatar v-else>
                <img class="user-image" src="/static/img/pro1.jpg" alt="User profile image" />
              </md-avatar>
            </md-button>
            <md-menu-content class="my-content">
                <router-link to="/team">
                <md-menu-item>
                  <md-icon>supervised_user_circle</md-icon>
                  <span class="clr-gray">Team</span>
                </md-menu-item>
              </router-link>
              <router-link to="/order-history">
                <md-menu-item>
                  <md-icon>shopping_cart</md-icon>
                  <span class="clr-gray">Order History</span>
                </md-menu-item>
              </router-link>
              <router-link to="/requested-list" v-if="isSupervisor">
                <md-menu-item>
                  <md-icon>local_mall</md-icon>
                  <span class="clr-gray">Requested List</span>
                </md-menu-item>
              </router-link>
              <router-link to="/profile">
                <md-menu-item>
                  <md-icon>account_circle</md-icon>
                  <span class="clr-gray">Profile</span>
                </md-menu-item>
              </router-link>
              <a href="https://launch-app.rcpanz.com/contactus/" target="_blank">
                <md-menu-item>
                  <md-icon>perm_phone_msg</md-icon>
                  <span class="clr-gray">Contact Us</span>
                </md-menu-item>
              </a>

                <router-link @click.native="logOut" to="/">
              <md-menu-item>
                <md-icon>lock</md-icon>
                <span class="clr-gray">Logout</span>
              </md-menu-item>
                </router-link>
            </md-menu-content>
          </md-menu>
        </li>
      </ul>
    </div>
     <div class="nav-gap-d"></div>
  </div>
  <!-- ======= Mobile View ====== -->
  <div class="displya-none-D">
    <div class="nev-mobile sticky">
      <div class="nev-right-m">
        <div style="width:100%">
          <div style="width:10%;float: right;">
             <div class="dropdown">
              <button @click="myFunction()" class="dropbtn"><md-icon>more_vert</md-icon></button>
              <div id="myDropdown" class="dropdown-content">
                <router-link to="/team" class="drop-ttx"><md-icon>supervised_user_circle</md-icon>&nbsp;&nbsp;<span>Team</span></router-link>
                <router-link to="/products" class="drop-ttx"><md-icon>shopping_cart</md-icon>&nbsp;&nbsp;<span>Products</span></router-link>
                <router-link to="/profile" class="drop-ttx"> <md-icon>account_circle</md-icon>&nbsp;&nbsp;<span>Profile </span></router-link>
                <div @click="logOut" class="lgout drop-ttx" > <md-icon>lock</md-icon>&nbsp;&nbsp;<span> Logout </span></div>
              </div>
            </div>
          </div>
          <div style="width:90%;">
           <div class="mainSearchBar">
             <input type="text" v-model="searchKeyWord" class="searchTerm searchMain" placeholder="What are you looking for?">
             <a :href="$router.resolve({path: '/search-items?search=' + searchKeyWord}).href">
               <button type="button" class="mainSearchButton">
                 <i class="fa fa-search"></i>
               </button>
             </a>
           </div>
          </div>
        </div>

      </div>
       <div class="nev-left-m">
          <a href="/"><img src="/static/img/crp-images/Logo_RCP_Smart_App.png" alt="Logo" class="nev-imglg" style=""></a>
      </div>
    </div>
    <div class="gap-header"></div>
    <div class="footer-mb">
      <ul class="ft-bar">
        <li class="ft-icon"><router-link to="/videos" class="ft-txt"><i class="fa fa-youtube-play ft-icon-fa" aria-hidden="true"></i><br>VIDEOS</router-link></li>
        <li class="ft-icon"><router-link to="/documents" class="ft-txt"><i class="fa fa-file-text ft-icon-fa" aria-hidden="true"></i><br> MANUALS</router-link></li>
        <li class="ft-icon"><router-link to="/catelogue" class="ft-txt"><i class="fa fa-book ft-icon-fa" aria-hidden="true"></i><br>CATALOGUE</router-link></li>
        <li class="ft-icon"><router-link to="/favourite" class="ft-txt"><i class="fa fa-heart ft-icon-fa" aria-hidden="true"></i><br>FAVOURITES</router-link></li>
      </ul>
    </div>
  </div>
   <!-- ================== Start products model ================== -->
     <md-dialog :md-active.sync="newModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Recommend to Supervisor
        <a style="float: right;cursor: pointer;" class="md-primary" @click="newModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
       <form class="from-padding modal-width-100" id="form" onsubmit="return false;">
          <div class="md-layout md-gutter">
            <div class="delete_all_crt" v-if="this.cartItemList.length > 0">
              <md-checkbox v-if="this.cartItemList.length > 1" style="margin: 0px 20px 0 0;" v-model="allSelected"  @change="toggleAll($event)"></md-checkbox>
               <div class="">
                <button type="button" class="btn delete_btn-my" @click="MultipleDelete" v-if="this.selectdIds.length > 0">
                  Delete
                </button>
              </div>
            </div>
             <div class="cart_list_user" v-for="(item, index) in cartItemList" :key="index">
               <div v-if="cartItemList.length > 1">
                 <md-checkbox style="margin: 10px;" v-model="selectdIds" :value="item.id" @change="checkList($event)"></md-checkbox>
               </div>
               <div class="item_image_cart_user">
                 <img :src='item.product_details.thumbnail_medium' />
               </div>
               <div class="item_data_cart_user">
                 <p class="pr_title_user">{{item.product_details.name}}</p>
                 <div  v-for="(item, index) in item" :key="index">
                  <p class="pr_datas_user" v-if="item != null && index != 'product_id' && index != 'id' && index != 'product_details' && index != 'product_description' && index != 'product_type_id' && index != 'qty' && index != 'status' && index != 'modify'  && index != 'color' && index != 'product_color_id' && index != 'product_item_id' && index != 'logs'   ">
                    {{convertToString(index) + ' = ' + item}}
                  </p>
                </div>
                  <p class="pr_datas_user">
                      Color = {{item.color.name}}
                  </p>
               </div>
               <div class="item_data_qty_user">
                  <div class="delete_crt">
                    <md-button class="md-icon-button" @click="removeCartItem(item.id)">
                      <md-icon style="font-size: 16px !important">delete</md-icon>
                    </md-button>
                  </div>
                 <p>Quantity</p>
                  <vue-numeric-input v-model='item.qty' :min="1" :step="1" align="center" @input="handleBlur(index, item.qty)"  controls-type="plusminus"></vue-numeric-input>
               </div>
             </div>
          </div>

         <div class="custom-modal-footer-spaces"></div>

         <div class="custom-modal-footer-container">
           <div class="custom-modal-footer-items">
             &nbsp;&nbsp;&nbsp;
             <button v-if="isChangeQTY" type="button" class="btn default_btn-my" @click="saveCart" >
               Save Cart
             </button>&nbsp;&nbsp;&nbsp;
             <button type="button" class="btn primary-btn-my" @click="proceedCart" >
               Proceed
             </button>
           </div>

           <div class="error-acction custom-modal-footer-items" v-if="isChangeQTY">
             <p style='margin: 0;'>
               Please click the <b>Save Cart</b> button before you leave.
             </p>
           </div>
         </div>

        </form>
    </md-dialog>
    <!-- ================== End products model ================== -->
 </div>
</template>

<script>
  import Vue from 'vue'
  import {mapState} from 'vuex'
  import UsersMenu from '../layout/UsersMenu'
  import api from '../../../../api'
  import VueNumericInput from 'vue-numeric-input'
  export default {
    name: 'UserDashHeader',
    components: {
      UsersMenu,
      VueNumericInput
    },
    data() {
      return {
        isChangeQTY: false,
        selectdIds: [],
        cartItemList: [],
        isSupervisor: false,
        newModal: false,
        searchKeyWord: '',
        proIMG: '',
        haveCart: false,
        itemCount: '',
        allSelected: false,
        itemArr: []
      }
    },
    props: ['user'],
    computed: {
      ...mapState([
        'userInfo'
      ])
    },
    created() {
      this.$root.$on('checkCartItem', () => {
        this.getCartItem()
      })
      this.getCartItem()
      this.CheckLogedUser()
      this.proIMG = Vue.auth.getUserImg()
      if (this.$route.query.search !== null && this.$route.query.search !== '' && this.$route.query.search) {
        this.searchKeyWord = this.$route.query.search
      }
    },
    methods: {
      handleBlur(indexNew, newQty) {
        // console.log(this.cartItemList)
        var valueChek = false
        var flag = true
        if (this.itemArr.length !== this.cartItemList.length) {
          for (let y = 0; y < this.cartItemList.length; y++) {
            let index = y
            let qty = parseInt(this.cartItemList[y].qty)
            this.itemArr.push({index, qty, valueChek})
          }
        } else {
          for (let x = 0; x < this.itemArr.length; x++) {
            if (this.itemArr[x].index === indexNew) {
              if (this.itemArr[x].qty === newQty) {
                this.itemArr[x].valueChek = false
              } else {
                this.itemArr[x].valueChek = true
              }
            }
          }
          for (let x = 0; x < this.itemArr.length; x++) {
            if (this.itemArr[x].valueChek) {
              this.isChangeQTY = true
              flag = false
            }
          }
          if (flag) {
            this.isChangeQTY = false
          }
        }
        // console.log(this.itemArr)
      },
      toggleAll(source) {
        this.selectdIds = []
        if (this.allSelected) {
          this.cartItemList.forEach(item => {
            this.selectdIds.push(item.id)
          })
        }
      },
      checkList(source) {
        var itemLength = this.cartItemList.length
        var checkedLength = this.selectdIds.length
        if (itemLength === checkedLength) {
          this.allSelected = true
        } else {
          this.allSelected = false
        }
      },
      CheckLogedUser() {
        api.request('get', '/check/supervisor')
        .then(response => {
          if (response.data.result === 'yes') {
            this.isSupervisor = true
            this.initDatatables()
          } else {
            this.isSupervisor = false
            this.initDatatables()
          }
        })
      },
      saveCart() {
        if (this.cartItemList.length <= 0) {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: 'No recodes found'})
        } else {
          api.request('post', '/admin/orders/create', { 'items': this.cartItemList })
            .then(response => {
              // this.newModal = false
              this.getCartItem()
              this.isChangeQTY = false
              this.itemArr = []
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Record updated successfully'})
            }).catch(error => {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      convertToString(Text) {
        var txt = Text.toLowerCase().replace(/_/g, ' ')
        var arr = txt.split(' ')
        var newArr = []
        arr.forEach(data => {
          newArr.push(data.charAt(0).toUpperCase() + data.slice(1))
        })
        return newArr.join(' ')
      },
      SearchItems() {
        this.$store.state.searchItem = this.searchKeyWord
        this.$root.$emit('clickedSomething')
        this.$router.push('/search-items')
      },
      getCartItem() {
        this.cartItemList = []
        api.request('get', '/admin/orders/datatable/userwice')
        .then(response => {
          var checkData = response.data.data.original.data
          if (checkData.length <= 0) {
            this.itemCount = 0
          } else {
            this.cartItemList = response.data.data.original.data[0].order_items
            if (this.cartItemList.length > 0) {
              this.itemCount = this.cartItemList.length
            } else {
              this.itemCount = 0
            }
          }
          this.isChangeQTY = false
          this.itemArr = []
        })
      },
      showCart() {
        this.getCartItem()
        this.newModal = true
      },
      MultipleDelete() {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('post', '/empty/cart/itemwise', { 'items': this.selectdIds })
              .then(response => {
                if (response.status === 200 || response.data.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.getCartItem()
                }
                this.selectdIds = []
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
                this.selectdIds = []
              })
          }
        })
      },
      removeCartItem(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/orderitems/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.data.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.getCartItem()
                }
                this.selectdIds = []
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
                this.selectdIds = []
              })
          }
        })
      },
      proceedCart() {
        if (this.cartItemList.length <= 0) {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: 'No recodes found'})
        } else {
          api.request('post', '/admin/orders/create', { 'items': this.cartItemList })
            .then(response => {
              api.request('get', '/proceed/orders/request')
              .then(response => {
                this.newModal = false
                this.getCartItem()
                if (this.isSupervisor) {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Rubbermaid admin will be with you shortly.'})
                } else {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'The Product Request has been sent to your Supervisor for approval.'})
                }
              }).catch(error => {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
            }).catch(error => {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      myFunction() {
        var bb = document.getElementById('myDropdown')
        if (bb.style.display === 'none') {
          bb.style.display = 'block'
        } else {
          bb.style.display = 'none'
        }
      },
      logOut() {
        Vue.auth.destroyToken()
      }
    },
    watch: {
      newModal: function(val) {
        if (val) {
          this.allSelected = false
          this.selectdIds = []
        }
      }
    }
  }
</script>
<style>

  /* .main-header > .navbar {
    margin-left: unset;
  } */
  .main-header .md-tabs {
    background-color: #3c8dbc !important;
  }
  .mainSearchButton {
  width: 40px;
  height: 36px;
  border: 0px solid #fecd2f;
  background: #D01F2E;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 20px;
}
.mainSearchBar {
  width: 100%;
  position: relative;
  display: flex;
}
button.mainSearchButton:hover {
  color: #b7aaaa;
}
</style>



// WEBPACK FOOTER //
// UserDashHeader.vue?7da49603